import React, { Fragment, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import FilesApi from 'remote/files'
import { Text } from 'components/base'
import { DirectoryIcon } from 'components/Utils/FileIcons'
import { selectors as AuthSelectors } from 'data/auth'
import { selectors as ConfigSelectors } from 'data/config'

const FromConfluence = ({ apiToken, apiEndpoint, onSpaceSelected }) => {
  const [rowActive, setRowActive] = useState(null)
  const [hasError, setErrors] = useState(false)
  const [spaces, setSpaces] = useState([])

  useEffect(() => {
    const fetchData = () =>
      FilesApi.fetchConfluenceSpaces({
        apiToken,
        apiEndpoint,
      })
        .then(result => setSpaces(result.getConfluenceSpaces))
        .catch(err => setErrors(err))
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Fragment>
      <Text.Title className="margin-bottom-small">Select a space</Text.Title>
      <p className="font-family-system font-size-normal shade-20 margin-bottom-large">
        All pages from this space will be imported into your Slite channel. This
        will include the full structure of all pages and their nested pages.
      </p>
      {hasError && (
        <div className="red margin-bottom-small">
          An unknown error occurred while importing data from Confluence. Please
          try again or reach out to support if the issue persists.
        </div>
      )}

      <div
        className={classNames([
          'radius-normal border-small border-shade-40 height-full padding-bottom-small',
        ])}
      >
        <div className="scroll-y" style={{ minHeight: 300 }}>
          {spaces.map(({ key, name }) => (
            <div
              onClick={() => {
                setRowActive(key)
                onSpaceSelected(key)
              }}
              className={classNames(
                [
                  'flexbox flexbox-row flexbox-align-center',
                  'pointer transition',
                  'padding-normal',
                  'shade-05 font-weight-large',
                ],
                rowActive === key && 'background-primary-shade-light primary'
              )}
              key={key}
            >
              <div className="margin-right-small">
                <DirectoryIcon size={12} />
              </div>
              <div className="ellipsis">{name}</div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  )
}

export default connect(state => {
  return {
    apiToken: AuthSelectors.getApiToken(state),
    apiEndpoint: ConfigSelectors.getApiEndpoint(state),
  }
})(FromConfluence)
